export default __webpack_public_path__ + "fonts/lato-v17-latin-regular.woff2";